import Api from "../api";

const ProductsModule = {
    namespaced: true,
    state: {
        products: []
    },
    actions: {
        REMOVE ({ commit, state, dispatch, rootState }, data) {
            if (window.ps && window.ps.eventDispatcher) {
                return window.ps.eventDispatcher.dispatch('delete_product_from_cart', {
                    id: product.id,
                    variant: product.id_attribute
                }).then(() => {
                    dispatch('SYNC_STATE_FOR_QUANTITY_CHANGE', null, { root: true });
                });
            } else {
                const products = {...state.products};
                commit('REMOVE', data);
                const url = rootState.config.cart_url
                    + '?delete=true'
                    + '&ajax=true'
                    + '&summary=true'
                    + '&allow_refresh=1'
                    + '&id_product=' + data.id
                    + '&ipa='+data.id_attribute
                    + (data.id_customization ? '&id_customization='+data.id_customization : '')
                    + '&token='+rootState.config.static_token;
                return Api.fetchJson(url).then((response) => {
                    commit('SET', products);
                    if (window.ajaxCart !== undefined) {
                        if (typeof response === 'object' && response !== null) {
                            ajaxCart.updateCart(response);
                        } else {
                            ajaxCart.updateCart(JSON.parse(response));
                        }
                    }
                    if (typeof prestashop !== 'undefined' && typeof prestashop.emit === 'function') {
                        prestashop.emit('updateCart', {
                            reason: {
                                idProduct: data.id,
                                idProductAttribute: data.id_attribute,
                                linkAction: 'delete-from-cart'
                            },
                            resp: {
                                cart: {
                                    products: []
                                }
                            }
                        })
                    }
                    return Promise.all([
                        dispatch('LOAD_PRODUCTS', null, { root: true }),
                        dispatch('SYNC_SUMMARY', null, { root: true }),
                        dispatch('LOAD_CARRIERS_AND_PAYMENTS', null, { root: true })
                    ]);
                });
            }
        },
        DECREASE_QUANTITY ({ dispatch, rootState }, data) {
            const quantity = data.quantity || 1;
            if (window.ps && window.ps.eventDispatcher) {
                return window.ps.eventDispatcher.dispatch('remove_from_cart', {
                    id: product.id,
                    variant: product.id_attribute,
                    quantity: quantity,
                }).then(() => {
                    dispatch('SYNC_STATE_FOR_QUANTITY_CHANGE', null, { root: true });
                });
            } else {
                let url;
                if (rootState.config.ps_version === '1.7') {
                    url = rootState.config.cart_url
                        + '?update=true'
                        + '&action=update'
                        + '&ajax=true'
                        + '&getproductprice=true'
                        + '&summary=true'
                        + '&allow_refresh=1'
                        + '&id_product=' + data.id
                        + '&ipa=' + data.id_attribute
                        + (data.id_customization ? '&id_customization='+data.id_customization : '')
                        + '&qty=' + quantity
                        + '&op=down'
                        + '&token=' + rootState.config.static_token;
                } else {
                    url = rootState.config.cart_url
                        + '?add=true'
                        + '&ajax=true'
                        + '&getproductprice=true'
                        + '&summary=true'
                        + '&allow_refresh=1'
                        + '&id_product=' + data.id
                        + '&ipa='+data.id_attribute
                        + (data.id_customization ? '&id_customization='+data.id_customization : '')
                        + '&qty='+quantity
                        + '&op=down'
                        + '&token='+rootState.config.static_token;
                }
                return Api.fetchJson(url).then((response) => {
                    let responseObject;
                    if (typeof response === 'object' && response !== null) {
                        responseObject = response;
                    } else {
                        responseObject = JSON.parse(response);
                    }
                    if (responseObject.errors) {
                        let error = responseObject.errors.join('<br>');
                        alert(error);
                    }
                    if (window.ajaxCart !== undefined) {
                        ajaxCart.updateCart(responseObject);
                    }
                    if (typeof prestashop !== 'undefined' && typeof prestashop.emit === 'function') {
                        prestashop.emit('updateCart', {
                            reason: {
                                idProduct: data.id,
                                idProductAttribute: data.id_attribute,
                                linkAction: 'delete-from-cart'
                            },
                            resp: {
                                cart: {
                                    products: []
                                }
                            }
                        })
                    }
                    return Promise.all([
                        dispatch('LOAD_PRODUCTS', null, { root: true }),
                        dispatch('SYNC_SUMMARY', null, { root: true }),
                        dispatch('LOAD_CARRIERS_AND_PAYMENTS', null, { root: true })
                    ]);
                });
            }
        },
        INCREASE_QUANTITY ({ dispatch, rootState }, data) {
            const quantity = data.quantity || 1;
            if (window.ps && window.ps.eventDispatcher) {
                return window.ps.eventDispatcher.dispatch('add_to_cart', {
                    id: data.id,
                    variant: data.id_attribute,
                    quantity: quantity,
                }).then(() => {
                    dispatch('SYNC_STATE_FOR_QUANTITY_CHANGE', null, { root: true });
                });
            } else {
                let url;
                if (rootState.config.ps_version === '1.7') {
                    url = rootState.config.cart_url
                        + '?update=true'
                        + '&action=update'
                        + '&ajax=true'
                        + '&getproductprice=true'
                        + '&summary=true'
                        + '&allow_refresh=1'
                        + '&id_product=' + data.id
                        + '&ipa=' + data.id_attribute
                        + (data.id_customization ? '&id_customization='+data.id_customization : '')
                        + '&qty=' + quantity
                        + '&token=' + rootState.config.static_token;
                } else {
                    url = rootState.config.cart_url
                        + '?add=true'
                        + '&ajax=true'
                        + '&getproductprice=true'
                        + '&summary=true'
                        + '&allow_refresh=1'
                        + '&id_product=' + data.id
                        + '&ipa=' + data.id_attribute
                        + (data.id_customization ? '&id_customization='+data.id_customization : '')
                        + '&qty=' + quantity
                        + '&token=' + rootState.config.static_token;
                }
                return Api.fetchJson(url).then((response) => {
                    let responseObject;
                    if (typeof response === 'object' && response !== null) {
                        responseObject = response;
                    } else {
                        responseObject = JSON.parse(response);
                    }
                    let productsPromises = [];
                    if (responseObject.errors) {
                        if (responseObject.cart) {
                            responseObject.cart.products.forEach((item) => {
                                if (item.cart_quantity > item.stock_quantity) {
                                    productsPromises.push(dispatch('SET_QUANTITY', {
                                        id: item.id_product,
                                        id_attribute: item.id_product_attribute,
                                        quantity: item.stock_quantity,
                                        cart_quantity: item.cart_quantity
                                    }))
                                }
                            })
                            alert(responseObject.errors);
                        }
                    }
                    if (window.ajaxCart !== undefined) {
                        ajaxCart.updateCart(responseObject);
                    }
                    if (typeof prestashop !== 'undefined' && typeof prestashop.emit === 'function') {
                        prestashop.emit('updateCart', {
                            reason: {
                                idProduct: data.id,
                                idProductAttribute: data.id_attribute,
                                linkAction: 'add-from-cart'
                            },
                            resp: {
                                cart: {
                                    products: []
                                }
                            }
                        })
                    }
                    return Promise.all(productsPromises).then(() => {
                        return Promise.all([
                            dispatch('LOAD_PRODUCTS', null, { root: true }),
                            dispatch('SYNC_SUMMARY', null, { root: true }),
                            dispatch('LOAD_CARRIERS_AND_PAYMENTS', null, { root: true })
                        ]);
                    })
                });
            }
        },
        SET_QUANTITY ({ dispatch }, data) {
            if (window.ps && window.ps.eventDispatcher) {
                if (data.quantity - data.cart_quantity < 0) {
                    return window.ps.eventDispatcher.dispatch('remove_from_cart', {
                        id: data.id,
                        variant: data.id_attribute,
                        quantity: Math.abs(data.quantity - data.cart_quantity),
                    }).then(() => {
                        dispatch('SYNC_STATE_FOR_QUANTITY_CHANGE');
                    });
                }
                if (data.quantity - data.cart_quantity > 0) {
                    return window.ps.eventDispatcher.dispatch('add_to_cart', {
                        id: data.id,
                        variant: data.id_attribute,
                        quantity: Math.abs(data.quantity - data.cart_quantity),
                    }).then(() => {
                        dispatch('SYNC_STATE_FOR_QUANTITY_CHANGE');
                    });
                }
            } else {
                if (data.quantity - data.cart_quantity < 0) {
                    return dispatch('DECREASE_QUANTITY', {
                        id: data.id,
                        id_attribute: data.id_attribute,
                        id_customization: data.id_customization,
                        quantity: Math.abs(data.quantity - data.cart_quantity)
                    })
                }
                if (data.quantity - data.cart_quantity > 0) {
                    return dispatch('INCREASE_QUANTITY', {
                        id: data.id,
                        id_attribute: data.id_attribute,
                        id_customization: data.id_customization,
                        quantity: Math.abs(data.quantity - data.cart_quantity)
                    })
                }
            }
        },
    },
    mutations: {
        SET (state, products) {
            state.products = products;
        },
        REMOVE (state, data) {
            const products = {};
            for (let key in state.products) {
                if (state.products.hasOwnProperty(key) === false) {
                    continue;
                }
                let product = state.products[key];
                if (product.id === data.id && product.id_attribute === data.id_attribute) {
                    continue;
                }
                products[key] = product;
            }
            state.products = products;
        }
    }
};

export default ProductsModule;
